import { StorePerson } from "@/store/constants";
import WaitTimer from '@/store/waitTimer';

import { appData, C, D, Rnd, Text } from "@/helpers/global";
import { PersonToken } from "@/services/requests/person_token";
import { PersonService } from "@/services/api/person";

const personStore = {
    namespaced: true,
    timer: {
        detail: new WaitTimer(StorePerson.state.detail, 10),
    },
    state: () => ({
        me: appData.fn.getLocal(StorePerson.state.me, {}),
        token: appData.fn.getLocal(StorePerson.state.token, {}),
    }),
    mutations: {
        set(state, data) {
            if (state?.me != data) {
                state.me = data;
                appData.fn.setLocal(StorePerson.state.me, data);
            }
        },
        setToken(state, data) {
            if (state?.token != data) {
                state.token = data;
                appData.fn.setLocal(StorePerson.state.token, data);
            }
        },
    },
    actions: {
        set(ctx, data) {
            ctx.commit("set", data);
        },
        login(ctx, data) {
            appData.cookie.delete(StorePerson.state.token);

            appData.fn.removeLocal(StorePerson.state.token);
            appData.fn.removeLocal(StorePerson.state.me);

            ctx.commit("setToken", data?.token);
            ctx.dispatch("set", {
                profile: data.profile,
                fullName: data.fullName,
                userName: data.userName,
                email: data.email,
            });
        },
        logout(ctx, isAll) {
            ctx.commit("set", {});
            ctx.commit("setToken", {});
            appData.cookie.delete(StorePerson.state.token);

            if(isAll) {
                sessionStorage.clear();
                localStorage.clear();
            }
            else {
                appData.fn.removeLocal(StorePerson.state.token);
                appData.fn.removeLocal(StorePerson.state.me);
            }
        },
    },
    getters: {
        get(state) {
            return state.me;
        },
        getToken(state) {
            return new PersonToken(state.token);
        },
        isLogin(state) {
            const token = new PersonToken(state.token);
            if (!Text.IsEmpty(token?.accessToken)) {
                var j = appData.fn.parseJwt(token.accessToken)
                if (j.exp) {
                    return j.exp >= Math.floor(Date.now() / 1000);
                }
            }
            return false;
        },
        isLoginWait(state) {
            const token = new PersonToken(state.token);
            if (!Text.IsEmpty(token?.accessToken)) {
                var j = appData.fn.parseJwt(token.accessToken)
                if (j.exp) {
                    return j.exp >= Math.floor(Date.now() / 1000) + 60;
                }
            }
            return false;
        },
    }
};
export default personStore;